import { ItemID } from "types/common";

// Ids sent to /filter as matched_item. Nothing ticked means every product of the brand.
// A brand with no products sends its own id: no row is ever matched to a brand, so the table shows nothing.
export const getMatchedItemIds = (brandId: ItemID, brandProductIds: ItemID[], tickedIds: ItemID[]): ItemID[] => {
  const ticked = tickedIds.filter((id) => brandProductIds.includes(id));
  if (ticked.length) return ticked;
  if (brandProductIds.length) return brandProductIds;
  return [brandId];
};

// The reverse, for restoring the checkboxes from the URL: every product sent means nothing ticked.
export const getTickedProductIds = (matchedItemIds: ItemID[], brandProductIds: ItemID[]): ItemID[] => {
  const inBrand = matchedItemIds.filter((id) => brandProductIds.includes(id));
  return inBrand.length === brandProductIds.length ? [] : inBrand;
};
